// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowPreview-cls1_Yx7","cls2":"BulkFollowPreview-cls2_mLu BulkFollowPreview-cls1_Yx7"};